import { render, staticRenderFns } from "./IDPhotoEnsure.vue?vue&type=template&id=3cac2732"
import script from "./IDPhotoEnsure.vue?vue&type=script&lang=js"
export * from "./IDPhotoEnsure.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports